import Chart from "chart.js/auto";
import { initialiseReportCharts } from "../components/trends/trend-charts";
import { initialiseSeoReportThumbCharts } from "../components/trends/trend-thumbs";
import { initialiseTrackedProductActions, initialiseDropshipProducts } from "../components/trends/trend-products";
import { initialiseClipboard, initialiseEmbedPreview } from "../components/trends/trend-embed";

window.Chart = Chart;
Chart.defaults.elements.line.borderWidth = 3;
Chart.defaults.elements.point.radius = 1;
Chart.defaults.elements.point.hoverRadius = 8;
Chart.defaults.plugins.legend.display = false;
Chart.defaults.font.size = 10;
Chart.defaults.animation = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? false : Chart.defaults.animation;

function initialise() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
        window.bootstrap?.Tooltip.getOrCreateInstance(element);
    });
    if (window.jQuery?.fn?.selectpicker) {
        window.jQuery(".js-interest-period-picker").selectpicker();
    }
    initialiseReportCharts();
    initialiseSeoReportThumbCharts();
    initialiseClipboard();
    initialiseEmbedPreview();
    initialiseTrackedProductActions();
    initialiseDropshipProducts();
    document.querySelectorAll('[data-trend-image-fallback]').forEach((image) => {
        image.addEventListener('error', () => { image.src = image.dataset.trendImageFallback; }, { once: true });
        if (image.complete && image.naturalWidth === 0) image.src = image.dataset.trendImageFallback;
    });
}
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
} else {
    initialise();
}


